import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinashtavinayakkdarshank() {



  const cardData = {
"keyword": "Force Urbania On Rent for Ashtavinayak Darshan",

"headingDescription":
  "Aaradhya Travels offers premium Force Urbania on Rent for Ashtavinayak Darshan from Pune for devotees seeking a comfortable, safe, and luxury pilgrimage experience. Our Force Urbania vehicles are ideal for the complete Ashtavinayak circuit covering all eight Ganpati temples with spacious pushback seats, powerful air-conditioning, smooth suspension, ample luggage space, and experienced drivers familiar with temple routes. Whether it is a one-day express darshan or a 2-day relaxed yatra, we ensure a peaceful, punctual, and hassle-free spiritual journey for families, senior citizens, and group pilgrims across Maharashtra.",

"topPlaces": [
  {
    "title": "Morgaon Mayureshwar Ganpati",
    "description":
      "Morgaon is the first and most important temple in the Ashtavinayak circuit, dedicated to Lord Mayureshwar. It is a highly sacred pilgrimage site known for its spiritual significance and traditional temple architecture, often the starting point of the Urbania-based luxury yatra from Pune."
  },
  {
    "title": "Siddhatek Siddhivinayak",
    "description":
      "Siddhatek temple is located on the banks of the Bhima River and is known for its peaceful surroundings and strong spiritual belief that Lord Ganesha fulfills wishes here. It is a key stop in the Ashtavinayak journey."
  },
  {
    "title": "Pali Ballaleshwar",
    "description":
      "Pali Ballaleshwar is unique among Ashtavinayak temples as it is named after a devoted child, Ballal. Surrounded by hills and greenery, it offers a calm and devotional atmosphere for pilgrims traveling in comfort via Urbania."
  },
  {
    "title": "Mahad Varadvinayak",
    "description":
      "Mahad Varadvinayak is an ancient temple known for its peaceful environment and belief of fulfilling devotees’ wishes. It is an important spiritual stop in the Ashtavinayak route."
  },
  {
    "title": "Theur Chintamani",
    "description":
      "Theur Chintamani temple is associated with removing worries and mental stress. Located near Pune, it is a frequently visited shrine in the Ashtavinayak circuit for family and group darshan."
  },
  {
    "title": "Lenyadri Girijatmaj",
    "description":
      "Lenyadri is a unique cave temple situated inside rock-cut hills and is the only Ashtavinayak temple located in a mountain cave structure, offering a spiritual trekking experience."
  },
  {
    "title": "Ozar Vighnahar",
    "description":
      "Ozar Vighnahar temple is known for its grand architecture and riverside location. It is one of the most important and peaceful stops in the Ashtavinayak pilgrimage journey."
  },
  {
    "title": "Ranjangaon Mahaganpati",
    "description":
      "Ranjangaon Mahaganpati is considered one of the most powerful forms of Lord Ganesha. It is the final temple in the Ashtavinayak circuit and marks the completion of the sacred journey."
  },
  {
    "title": "Bhima River Scenic Route",
    "description":
      "The Ashtavinayak route passes through scenic rural Maharashtra landscapes, river valleys, and peaceful villages, making the journey itself spiritually enriching and comfortable in a luxury Urbania van."
  },
  {
    "title": "Temple Circuit Experience",
    "description":
      "The complete Ashtavinayak yatra covers all eight sacred Ganpati temples in a traditional sequence, offering devotees a full spiritual experience with comfort, safety, and smooth travel in Force Urbania vehicles."
  }
],



services: [
  {
    name: "Pune to Ashtavinayak Urbania Tour Package from Pune",
    description: "Pune to Ashtavinayak Urbania tour package from Pune service provides comfortable premium transportation for devotees visiting the sacred Ashtavinayak temples across Maharashtra. Spacious luxury seating and smooth highway travel ensure pleasant pilgrimage journeys suitable for families, senior citizens, and spiritual groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ashtavinayak Urbania package reservations."
  },
  {
    name: "Cheapest Ashtavinayak Tour from Pune",
    description: "Cheapest Ashtavinayak tour from Pune service offers affordable and reliable transportation for Ganpati temple darshan tours, pilgrimage journeys, and spiritual travel. Comfortable vehicles ensure smooth travel experiences suitable for devotees, families, and tourist groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient budget Ashtavinayak tour reservations."
  },
  {
    name: "13 Seater Urbania on Rent for Ashtavinayak Tour from Pune",
    description: "13 seater Urbania on rent for Ashtavinayak tour from Pune service provides luxurious transportation for medium-sized family groups, pilgrimage tours, and temple darshan journeys. Spacious seating and modern interiors ensure comfortable long-distance travel suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the temple route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent for Ashtavinayak Tour from Pune",
    description: "17 seater Urbania on rent for Ashtavinayak tour from Pune service offers spacious premium transportation for large family groups, pilgrimage travel, and spiritual journeys across Ashtavinayak temples. Comfortable luxury seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "Pune to Ranjangaon Ganpati Darshan Urbania",
    description: "Pune to Ranjangaon Ganpati Darshan Urbania service provides comfortable transportation for devotees visiting the famous Mahaganpati temple at Ranjangaon from Pune. Spacious luxury interiors ensure smooth highway travel suitable for pilgrimage journeys and family temple visits. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ranjangaon Urbania reservations."
  },
  {
    name: "Pune to Siddhivinayak Temple Siddhatek Urbania",
    description: "Pune to Siddhivinayak Temple Siddhatek Urbania service offers premium transportation for devotees traveling to the sacred Siddhivinayak temple at Siddhatek from Pune. Spacious seating and comfortable interiors ensure smooth pilgrimage travel suitable for spiritual groups and families. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Siddhatek Urbania reservations."
  },
  {
    name: "Pune to Morgaon Moreshwar Urbania on Rent",
    description: "Pune to Morgaon Moreshwar Urbania on rent service provides luxurious transportation for temple darshan tours and pilgrimage journeys to the revered Moreshwar Ganpati temple from Pune. Spacious seating and smooth travel performance ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Morgaon Urbania reservations."
  },
  {
    name: "Pune to Pali Ballaleshwar Urbania",
    description: "Pune to Pali Ballaleshwar Urbania service offers dependable premium transportation for devotees visiting the sacred Ballaleshwar Ganpati temple at Pali from Pune. Comfortable luxury seating and spacious interiors ensure smooth highway travel suitable for spiritual journeys and family temple visits. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Pali Urbania reservations."
  },
  {
    name: "Pune to Mahad Varad Vinayak Urbania",
    description: "Pune to Mahad Varad Vinayak Urbania service provides reliable transportation for devotees traveling to the Varad Vinayak temple at Mahad from Pune. Spacious luxury interiors and smooth highway travel ensure comfortable pilgrimage experiences suitable for families and spiritual groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahad Urbania reservations."
  },
  {
    name: "Pune to Theur Chintamani Urbania",
    description: "Pune to Theur Chintamani Urbania service offers premium transportation for temple darshan tours and spiritual journeys to the famous Chintamani Ganpati temple at Theur from Pune. Spacious seating and comfortable interiors ensure smooth local and highway travel suitable for devotees and families. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Theur Urbania reservations."
  },
  {
    name: "Pune to Lenyadri Girijatmaj Urbania",
    description: "Pune to Lenyadri Girijatmaj Urbania service provides luxurious transportation for devotees visiting the sacred Girijatmaj Ganpati temple at Lenyadri from Pune. Spacious seating and smooth travel performance ensure comfortable ghat road journeys suitable for pilgrimage groups and family travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Lenyadri Urbania reservations."
  },
  {
    name: "Pune to Ozar Vighnahar Urbania",
    description: "Pune to Ozar Vighnahar Urbania service offers reliable premium transportation for devotees traveling to the Vighnahar Ganpati temple at Ozar from Pune. Comfortable luxury interiors and smooth highway travel ensure pleasant pilgrimage journeys suitable for spiritual and family travel. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ozar Urbania reservations."
  },
  {
    name: "Ashtavinayak Darshan Private Urbania Booking Pune",
    description: "Ashtavinayak Darshan private Urbania booking Pune service provides exclusive premium transportation for Ganpati temple tours, spiritual journeys, and family pilgrimage travel from Pune. Spacious luxury seating and private travel comfort ensure smooth darshan experiences suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient private Urbania reservations."
  },
  {
    name: "Urbania for Pilgrimage Tour Pune",
    description: "Urbania for pilgrimage tour Pune service offers luxurious transportation for spiritual journeys, temple visits, Jyotirlinga darshan tours, and religious group travel from Pune. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for devotees, senior citizens, and families. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient pilgrimage Urbania reservations."
  },
  {
    name: "Luxury Urbania for Temple Tour Pune",
    description: "Luxury Urbania for temple tour Pune service provides premium transportation for Ganpati darshan, pilgrimage travel, sightseeing tours, and spiritual journeys from Pune. Spacious luxury seating and smooth highway performance ensure comfortable travel experiences suitable for temple visitors and family groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient temple tour Urbania reservations."
  }
],

tableData: [
  ["Pune to Ashtavinayak Urbania Tour Package from Pune", "Cheapest Ashtavinayak Tour from Pune"],
  ["13 Seater Urbania on Rent for Ashtavinayak Tour from Pune", "17 Seater Urbania on Rent for Ashtavinayak Tour from Pune"],
  ["Pune to Ranjangaon Ganpati Darshan Urbania", "Pune to Siddhivinayak Temple Siddhatek Urbania"],
  ["Pune to Morgaon Moreshwar Urbania on Rent", "Pune to Pali Ballaleshwar Urbania"],
  ["Pune to Mahad Varad Vinayak Urbania", "Pune to Theur Chintamani Urbania"],
  ["Pune to Lenyadri Girijatmaj Urbania", "Pune to Ozar Vighnahar Urbania"],
  ["Ashtavinayak Darshan Private Urbania Booking Pune", "Urbania for Pilgrimage Tour Pune"],
  ["Luxury Urbania for Temple Tour Pune", "Pune to Ashtavinayak Urbania Tour Package from Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Force Urbania On Rent for Ashtavinayak Darshan",
        WhyChoosedescription: "Aaradhya Travels provides reliable Force Urbania rental service for Ashtavinayak Darshan with premium vehicles, experienced drivers, and smooth travel arrangements for comfortable pilgrimage journeys."
      },
      {
        WhyChooseheading: "Affordable Ashtavinayak Urbania Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Force Urbania rental packages for Ashtavinayak Darshan with transparent pricing, flexible travel plans, and complete booking assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking for Temple Tours",
        WhyChoosedescription: "Our Force Urbania booking service for Ashtavinayak Darshan operates 24 hours for family pilgrimage tours, group darshan trips, weekend travel, and customized temple journeys."
      },
      {
        WhyChooseheading: "Luxury & Fully AC Force Urbania Vehicles",
        WhyChoosedescription: "All Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and equipped with premium seating for comfortable long-distance pilgrimage travel."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Ashtavinayak Tours",
        WhyChoosedescription: "Aaradhya Travels offers one-day Ashtavinayak Darshan tours, multi-day temple packages, weekend pilgrimage journeys, and customized spiritual travel plans according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Group Pilgrimage Travel",
        WhyChoosedescription: "Force Urbania vehicles are ideal for family darshan tours, senior citizen pilgrimage travel, group temple visits, corporate spiritual trips, and comfortable Maharashtra temple journeys."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ashtavinayak Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with all Ashtavinayak temple routes and ensure safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Force Urbania on rent for Ashtavinayak Darshan?", answer: "Force Urbania rental service for Ashtavinayak Darshan provides premium group transportation for visiting all eight famous Ganpati temples in Maharashtra." },
    { question: "Is Force Urbania booking available 24 hours for Ashtavinayak Darshan?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania rental service for Ashtavinayak Darshan tours." },
    { question: "Can I book Force Urbania for one-day Ashtavinayak tour?", answer: "Yes, customers can book one-day as well as multi-day Ashtavinayak Darshan Force Urbania packages." },
    { question: "Do you provide customized Ashtavinayak travel packages?", answer: "Yes, Aaradhya Travels provides customized pilgrimage and temple travel packages according to customer requirements." },
    { question: "Are all Force Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Force Urbania online for Ashtavinayak Darshan?", answer: "Yes, customers can easily book Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Force Urbania for family and group pilgrimage tours?", answer: "Yes, Aaradhya Travels provides spacious Force Urbania vehicles suitable for families, senior citizens, and group darshan travel." },
    { question: "Are Force Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Ashtavinayak Darshan Urbania service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Joshi",
    feedback:
      "Our Ashtavinayak Darshan journey with Force Urbania on rent was extremely comfortable and well organized. The vehicle offered great space, smooth travel, and made the long temple route very relaxing for everyone.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Madhuri Deshpande",
    feedback:
      "Force Urbania rental for Ashtavinayak Darshan turned out to be a very comfortable travel option for our group. The ride quality was smooth, seating was premium, and the overall experience was peaceful throughout the trip.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania On Rent for Ashtavinayak Darshan",
  "image": "https://www.aaradhyatravels99.com/assets/images/force-urbania-ashtavinayak-darshan.jpg",
  "description": "Book Force Urbania on rent for Ashtavinayak Darshan with Aaradhya Travels. Premium 13 and 17 seater Urbania available for comfortable pilgrimage tours covering Ranjangaon, Siddhatek, and other Ashtavinayak temples from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2294"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/force-urbania-on-rent-for-ashtavinayak-darshan"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Force Urbania On Rent for Ashtavinayak Darshan | Pune Tour Package | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Force Urbania for Ashtavinayak Darshan from Pune with Aaradhya Travels. Premium 13 and 17 seater Urbania available for Ranjangaon, Siddhatek, and full Ashtavinayak pilgrimage tour packages with comfort and safety."
  />

  <meta
    name="keywords"
    content="Pune to Ashtavinayak Urbania tour package from Pune, Cheapest Ashtavinayak tour from Pune, 13 Seater Urbania on rent for Ashtavinayak tour from Pune, 17 Seater Urbania on rent for Ashtavinayak tour from Pune, Pune to Ranjangaon Ganpati Darshan Urbania, Pune to Siddhivinayak Temple Siddhatek"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbaniaonrentinashtavinayakkdarshank;